<template>
  <sui-form-field class="double-field" :width="10">
    <sui-form-field>
      <label>
        Access until
      </label>
      <sui-input class="small" type="date" v-model="date" :min="minDate" @input="onInput" />
    </sui-form-field>
    <sui-form-field>
      <label>
        <span style="opacity: 0">.</span>
        <span class="reset" @click.prevent="reset()">reset</span>
      </label>
      <sui-input class="small" type="time" v-model="time" @input="onInput" />
    </sui-form-field>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'
  import utils from '@/utils'

  export default {
    name: 'MemberExpiration',
    mixins: [
      FormField,
    ],
    data() {
      return {
        isTimeSelected: false,
        minDate: this.getDate(),
        newDate: this.getDate(this.$attrs.value),
        newTime: this.getTime(this.$attrs.value),
      }
    },
    computed: {
      datetime() {
        const time = this.newTime || '23:59'
        const date = this.newDate || this.getDate()
        return (this.newDate || this.newTime) ? new Date(`${date}T${time}:00`).toISOString() : ''
      },
      date: {
        get() {
          return this.$attrs.value ? this.getDate(this.$attrs.value) : ''
        },
        set(date) {
          this.newDate = date
        },
      },
      time: {
        get() {
          return this.$attrs.value ? this.getTime(this.$attrs.value) : ''
        },
        set(time) {
          this.newTime = time
        },
      },
    },
    watch: {
      datetime(datetime) {
        this.$attrs.value = datetime
        this.onInput()
      },
    },
    methods: {
      getDate(text) {
        const date = text ? new Date(text) : new Date()
        const year = date.getFullYear()
        const month = utils.padZero(date.getMonth() + 1)
        const day = utils.padZero(date.getDate())
        return `${year}-${month}-${day}`
      },
      getTime(text) {
        const date = text ? new Date(text) : new Date()
        const hours = utils.padZero(date.getHours())
        const minutes = utils.padZero(date.getMinutes())
        return `${hours}:${minutes}`
      },
      reset() {
        this.newDate = ''
        this.newTime = ''
      },
    },
  }
</script>

<style scoped>
  .double-field { display: flex; justify-content: space-between; }
  .double-field > .field { width: 43%; }
  .double-field > .field:first-child { width: 53%; }
  .reset { float: right; color: #4183C4; }
  .reset:hover { color: #1e70bf; cursor: pointer; }
</style>
